import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { HeartIcon, ShieldCheckIcon, UserGroupIcon, ViewfinderCircleIcon } from '@heroicons/react/24/outline';

const ValuesSection = () => {
  const values = [
    {
      icon: HeartIcon,
      title: "We See Your Strength",
      description: "You've lived a full life with wisdom and experience. We honor that by focusing on your capabilities and supporting your goals, not dwelling on limitations."
    },
    {
      icon: ShieldCheckIcon,
      title: "We Understand Your Concerns",
      description: "Worrying about safety or being a burden is natural. We validate these feelings while providing practical tools to address them with confidence."
    },
    {
      icon: UserGroupIcon,
      title: "We Respect Your Relationships",
      description: "Family dynamics around aging can be complex. We facilitate better communication and coordination while preserving your independence and dignity."
    },
    {
      icon: ViewfinderCircleIcon,
      title: "We Meet You Where You Are",
      description: "Every person's aging journey is unique. We adapt to your current situation, goals, and comfort level with technology and change."
    }
  ];

  return (
    <div className="py-20 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">Our Values</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            We understand the emotional journey of aging at home and support you with compassion and respect.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating transition-all duration-300 group">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 rounded-md flex items-center justify-center flex-shrink-0 group-hover:transition-colors">
                  <value.icon className="w-7 h-7 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-foreground mb-4">{value.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ValuesSection;